
export enum OpenTicketPassType {
  Standard = 'Standard',
  Protocol = 'Protocol',
  Refund = 'Refund',
}
